<template>
  <div :data-form-id="formId">
    <h3
      v-if="title"
      :class="{
        'ds-heading-xsmall ds-margin-bottom-24': !description,
        'ds-heading ds-margin-bottom-12': description,
        'ds-text-align-center': centerTitle
      }"
    >
      {{ title }}
    </h3>
    <p
      v-if="description"
      class="ds-text ds-margin-bottom-48"
      :class="{
        'ds-text-align-center': centerTitle
      }"
    >
      {{ description }}
    </p>

    <DsPlaceholderLoader v-if="formFetchStatus === 'pending'" />
    <ClientOnly>
      <DsForm
        v-if="formId && formFetchStatus !== 'pending' && formFields.length > 0"
        :key="'contact-form-' + formId"
        :data-form-id="formId"
        :form-id="formId + ''"
        :fields="computedFormFields"
        :submit-state="formSubmitState"
        :submit-label="customFormLabels.formSubmitLabelContact || formLabels.formSubmitLabelContact"
        :submit-success-label="
          customFormLabels.formSubmitStateSuccessMessage || formLabels.formSubmitStateSuccessMessage
        "
        :submit-fail-label="customFormLabels.formSubmitStateFailMessage || formLabels.formSubmitStateFailMessage"
        submit-color="black"
        @submit="onFormSubmit"
        @change.once="trackFormInteraction"
      />

      <RichText
        v-if="formLabels?.formDisclaimerMessage"
        :data="formLabels.formDisclaimerMessage"
        class="ds-margin-top-12"
      />
    </ClientOnly>
  </div>
</template>
<script setup>
import { DsForm, DsPlaceholderLoader } from 'awds'
import { defaultFormProps, useForms } from '../composables/useForms'

const emit = defineEmits(['success'])

const props = defineProps({
  ...defaultFormProps,
  title: { type: String, default: '' },
  description: { type: String, default: null },
  centerTitle: { type: Boolean, default: false },
  /**
   * Object config to override fields config (like labels and infoMessage)
   * where `key` is the field name and `value` is an object representing the field config
   *
   * @example
   * {
   *   firstName: { label: 'Custom first name label' },
   *   Form_text_2__c: { label: 'Custom message label', infoMessage: 'custom infor message with long description' }
   * }
   */
  customFieldsConfig: { type: Object, default: null },
  customFormLabels: { type: Object, default: () => ({}) }
})

const {
  formFields,
  FORM_SUBMIT_STATE,
  formSubmitState,
  formFetchStatus,
  formLabels,
  formSubmit,
  trackFormInteraction
} = useForms(() => props.formId + '', emit)

const computedFormFields = computed(() => {
  if (!props.customFieldsConfig) {
    return formFields.value
  }
  return formFields.value.map((field) => ({
    ...field,
    ...(props.customFieldsConfig?.[field.name] && { ...props.customFieldsConfig[field.name] })
  }))
})

const onFormSubmit = (data) => {
  if (data.type) {
    // This is a normal event, discard
    return
  }
  formSubmit(data)
}
</script>
